<div class="apps-page">

  <h2 class="page-title">Forms & Applications</h2>

  <div class="apps-grid">
    <a class="app-card" *ngFor="let app of apps" [routerLink]="app.route">
      <div class="icon-wrap" [innerHTML]="app.svg"></div>
      <span class="title">{{ app.title }}</span>
    </a>
  </div>

</div>
